import { GroupingFactorDataDriven } from "../ars_ldm";
import { isNamedObject } from "./isNamedObject";
import { isObjectRecord } from "./isObjectRecord";

/**
 * Type guard to check if a value is a GroupingFactorDataDriven.
 *
 * Validates that the object has the required properties of a GroupingFactorDataDriven:
 * - NamedObject properties
 * - id: string
 * - groupingDataset: string
 * - groupingVariable: string
 * - dataDriven: true
 * - dataValues: string[]
 *
 * @param obj - The value to check
 * @returns True if the object is a GroupingFactorDataDriven
 */
export const isGroupingFactorDataDriven = (obj: unknown): obj is GroupingFactorDataDriven => {
  if (!isObjectRecord(obj)) return false;
  // Check NamedObject properties
  if (!isNamedObject(obj)) return false;
  // Check required properties and their types
  if (obj.dataDriven !== true) return false;
  if (typeof obj.id !== "string") return false;
  if (typeof obj.groupingDataset !== "string") return false;
  if (typeof obj.groupingVariable !== "string") return false;
  if (!Array.isArray(obj.dataValues)) return false;
  if (obj.dataValues.some((v) => typeof v !== "string")) return false;
  // Everything is good
  return true;
};
